<div class="form mx-auto d-flex align-items-center justify-content-start pt-3 pb-5 px-3 px-md-5">
  <div class="form-container w-100">
    <div class="logo-header d-flex align-items-center my-4 pt-5 p-md-0">
      <img
        src="assets/images/logo_legatus_fundo_claro_1.webp"
        alt="Legatus Growth Partner"
        title="Legatus Growth Partner"
        class="logo-legatus" />
    </div>
    <div class="form__header my-3">
      <h2 class="form__header__title mb-2 mb-md-4">
        {{ tk.Auth.WelcomeMessage | t }}
      </h2>
      <p class="form__header__subtitle mb-3">{{ tk.Auth.LoginPrompt | t }}</p>
    </div>
    <div class="form-body">
      <form *ngIf="loginForm" [formGroup]="loginForm" appAutoFormGroup>
        <div class="form-group">
          <app-input
            id="passwordFormemail"
            [type]="'email'"
            [placeholder]="tk.General.Insert | t"
            [controlName]="loginProps.email"
            [label]="tk.Auth.FieldEmail | t"
            [required]="true"></app-input>

          <app-input
            id="passwordFormpassword"
            [type]="'password'"
            [controlName]="loginProps.password"
            [placeholder]="tk.General.Insert | t"
            [label]="tk.Auth.FieldPassword | t"
            [required]="true"></app-input>
        </div>

        <div class="form-group mb-3 mt-4">
          <app-button
            [type]="'submit'"
            [id]="'submit'"
            [label]="isLoading ? loadingMessage : (tk.Auth.SiginButton | t)"
            [disabled]="isLoading || !loginForm.valid"
            (sendButtonClick)="doLogin()"></app-button>
        </div>
        <div class="form-group mb-4 d-flex justify-content-center">
          <app-button
            [type]="'button'"
            [id]="'passwordRecovery'"
            [label]="tk.Auth.LastPasswordLabel | t"
            [theme]="'link'"
            [fitContent]="true"
            (sendButtonClick)="handleFormMode($event)"></app-button>
        </div>
        <div class="form-group mb-5 d-flex justify-content-center">
          <app-button
            [type]="'button'"
            [id]="'firstAccess'"
            [label]="tk.Auth.FirstAccessLabelQ | t"
            [theme]="'link'"
            [fitContent]="true"
            (sendButtonClick)="handleFormMode($event)"></app-button>
        </div>
      </form>
    </div>
  </div>
</div>
